export default {
  hazardWarrantyId: 13,
  hazardWarrantyPercentage: 0.195, // 19.5%
  hazardWarrantyMinPrice: 24.99,
  tpmsServiceKitId: 22,
  tpmsServiceUnitPrice: 9.99,
};
